import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs, ptlUtils } from "../../../comn";

/*
 * HS Code Management
 * !== HS 관리 기능 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/ctra/hscd`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/ctra/hscd`,
    nodes: [{ label: "Portal" }, { label: "Criteria Information Management" }, { label: "HS Code" }],
};

export const URLS = {
    osci0401001q: `${BASE.path}/osci0401001q`, // HS CODE MANEGEMENT List
    osci0401002q: `${BASE.path}/osci0401002q`, // HS CODE MANEGEMENT List Detail
    osci0401003s: `${BASE.path}/osci0401003s`, // HS CODE MANEGEMENT Regist / Modify
};

export const APIS = {
    // Get the List of HS Code Management !== HS 관리 목록 조회 ==!
    getOsciHsMgmtPageList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Save the HS Code Management !== HS 관리 저장 ==!
    saveOsciHsMgmt: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // Delete the HS Code Management !== HS 관리 삭제 ==!
    deleteosciHsMgmt: (tin: any) => {
        return api.delete(`${BASE.api}/${tin}`);
    },
    // Get HS Detail Select !== HS 상세 조회 ==!
    // url 로 파라미터 넘김
    getOsciHsCdNode: (hsCd: any, hsDgt: any) => {
        return api.get(`${BASE.api}/${hsCd}/${hsDgt}`);
    },
    // Get HS Detail Select !== HS 상세 조회 ==!
    // url 로 파라미터 넘김
    getOsciClcuTaxTest: () => {
        return api.get(`${BASE.api}/tax`);
    },
    // Save the HS Code Management !== HS 관리 저장 ==!
    saveOsciHsExcelUpload: (data: any) => {
        return api.post(`${BASE.api}/upload`, {
            ...data,
        });
    },
};
const optionYn = [
    { label: "Y", value: "Y" },
    { label: "N", value: "N" },
];

// HS Code Management Search Form Schema !== HS 관리 검색 폼 스키마 ==!
export const SF_HS_MGMT_SRCH: TFormSchema = {
    id: "form_OsciHsMgmtSrch",
    schema: {
        hsCd: {
            type: "text",
            label: "L_HS",
            area: "hsCd",
            controlSize: 2,
            // rightButton: { icon: "search" },
            placeholder: "0000.00.00.0000",
            mask: [/\d/, /\d/, /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, /\d/, /\d/],
        },
        hsDesc: { type: "text", label: "L_HS_DESC", area: "hsDesc", controlSize: 4 },
        useYn: {
            type: "select",
            label: "L_APPD_YN",
            controlSize: 1,
            all: true,
        },
        hsDgt: {
            type: "radio",
            area: "comnCd",
            comnCd: "OSC0048",
            excludes: ["0"],
            label: "L_HS_DGT",
            defaultValue: "12",
        },
    },
};

// HS Code Management List Grid !== HS 관리 List Grid ==!
export const SG_HS_MGMT_LST: TGridSchema = {
    id: "grid",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_HS_CD", binding: "hsCd", width: 150 }] },
        { cells: [{ header: "L_VERSION", binding: "histSrno", width: 100 }] },
        { cells: [{ header: "L_HS_DESC", binding: "hsDesc", width: "*" }] },
        { cells: [{ header: "L_QTY", binding: "itmQtyUtCd", width: 150 }] },
        { cells: [{ header: "L_APPD_YN", binding: "useYn", width: 80 }] },
    ],
    body: [
        {
            cells: [{ binding: "hsCd" }],
        },
        {
            cells: [{ binding: "histSrno" }],
        },
        {
            cells: [{ binding: "hsDesc" }],
        },
        {
            cells: [{ binding: "itmQtyUtCd" }],
        },
        {
            cells: [{ binding: "useYn" }],
        },
    ],
};
// Schema of HS Detail Select Form !== HS 상세 조회 폼 스키마 ==!
export const SF_HS_DTL_SRCH: TFormSchema = {
    id: "form_HsDtlSrch",
    schema: {
        hsCdSrch: {
            type: "text",
            label: "L_HS_CD",
            controlSize: 2,
            rightButton: { icon: "search" },
            mask: [/\d/, /\d/, /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, /\d/, /\d/],
        },
        hsCd: {
            type: "text",
            label: "L_HS_CD",
            controlSize: 9,
            labelSize: 3,
            mask: [/\d/, /\d/, /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, /\d/, /\d/],
        },
        hs2Cd: {
            label: "L_HS_CD",
            controlSize: 2,
            required: true,
        },
        hs4Cd: {
            label: "L_HS_CD",
            controlSize: 2,
            required: true,
        },
        hs6Cd: {
            label: "L_HS_CD",
            controlSize: 2,
        },
        hs8Cd: {
            label: "L_HS_CD",
            controlSize: 2,
        },
        hs12Cd: {
            label: "L_HS_CD",
            controlSize: 2,
        },
        hs2Desc: { type: "text", label: "L_CHPT_DESC", controlSize: 9, labelSize: 3 },
        hs4Desc: { type: "text", label: "L_HADG_DESC", controlSize: 9, labelSize: 3 },
        hs6Desc: { type: "text", label: "L_SUB_HADG_DESC", controlSize: 9, labelSize: 3 },
        hs8Desc: { type: "text", label: "L_TRIF_ITM_DESC", controlSize: 9, labelSize: 3 },
        hsDesc: { type: "text", label: "L_CMDT_DESC", controlSize: 9, labelSize: 3 },
        itmQtyUtCd: {
            type: "code",
            label: "L_QTY_UT",
            area: "comnCd",
            comnCd: "OSC0031",
            labelSize: 3,
            controlSize: 3,
        },
        useYn: {
            type: "select",
            label: "L_USE_YN",
            labelSize: 3,
            controlSize: 3,
            options: optionYn,
            select: false,
            all: true,
        },
        brndYn: {
            type: "select",
            label: "L_BRND_YN",
            options: [{ label: "Y", value: "Y" }],
            controlSize: 3,
            labelSize: 3,
        },
        cpntYn: {
            type: "select",
            label: "L_CPNT_YN",
            options: [{ label: "Y", value: "Y" }],
            controlSize: 3,
            labelSize: 3,
        },
        regstId: { type: "text", label: "L_RGST_ID", controlSize: 9, labelSize: 3 },
    },
};
// Schema of HS Detail Search Form !== HS 검색 폼 스키마 ==!
export const SF_HS_REG_SRCH: TFormSchema = {
    id: "form_HsRegSrch",
    schema: {
        hs2Cd: {
            label: "L_HS_CD",
            controlSize: 2,
            required: true,
        },
        hs4Cd: {
            label: "L_HS_CD",
            controlSize: 2,
            required: true,
            mask: [/\d/, /\d/, /\d/, /\d/],
        },
        hs6Cd: {
            label: "L_HS_CD",
            controlSize: 2,
            mask: [/\d/, /\d/],
        },
        hs8Cd: {
            label: "L_HS_CD",
            controlSize: 2,
            mask: [/\d/, /\d/],
        },
        hs12Cd: {
            label: "L_HS_CD",
            controlSize: 2,
            mask: [/\d/, /\d/, /\d/, /\d/],
        },
        hsCd: {
            label: "L_HS_CD",
            controlSize: 2,
        },
        hs2Desc: { label: "L_CHPT_DESC", controlSize: 10, required: true },
        hs4Desc: { label: "L_HADG_DESC", controlSize: 10, required: true },
        hs6Desc: { label: "L_SUB_HADG_DESC", controlSize: 10, required: true },
        hs8Desc: { label: "L_TRIF_ITM_DESC", controlSize: 10, required: true },
        hsDesc: { label: "L_CMDT_DESC", controlSize: 10, required: true },
        itmQtyUtCd: {
            type: "code",
            label: "L_QTY",
            required: true,
            area: "comnCd",
            comnCd: "OSC0031",
        },
        useYn: {
            type: "select",
            label: "L_APPD_YN",
            controlSize: 1,
            all: true,
            required: true,
        },
        regstId: { label: "L_REGST_ID", controlSize: 2 },
        mode: { label: "mode", controlSize: 2 },
    },
};

// Schema of HS Code Profile Detail Form !== HS Profile 폼 스키마 ==!
export const SF_HS_PRFL_DTL: TFormSchema = {
    id: "form_OsciHsPrflDtl",
    schema: {
        hsCd: {
            type: "text",
            label: "L_HS",
            area: "hsCd",
            controlSize: 2,
            // rightButton: { icon: "search" },
            placeholder: "0000.00.00.0000",
            mask: [/\d/, /\d/, /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, /\d/, /\d/],
        },
        hsDesc: { type: "text", label: "L_HS_DESC", area: "hsDesc", controlSize: 10 },
        itmQtyUtCd: {
            type: "code",
            label: "L_ITM_QTY_UT_CD",
            area: "comnCd",
            comnCd: "OSC0031",
        },
        hsPrflSubTpCd: {
            type: "checkbox",
            label: "L_HS_PRFL",
            area: "comnCd",
            comnCd: "OSC0046",
        },
    },
};
//Schema of HS Code Excel Upload List Grid !== HS Code Excel Upload 목록 그리드 ==!
export const SG_HS_EXCEL_UPLOAD_LST: TGridSchema = {
    id: "grid",
    options: { pagination: "in", edit: false, checkbox: false, index: true },
    head: [
        { cells: [{ header: "L_DGT", binding: "hsDgt", width: "5%" }] },
        { cells: [{ header: "L_HS_CD", binding: "hsCd", width: "10%" }] },
        { cells: [{ header: "L_HS_DESC", binding: "hsDesc", width: "*" }] },
        { cells: [{ header: "L_QTY_UT_CD", binding: "itmQtyUtCd", width: "10%" }] },
        { cells: [{ header: "L_HS_DTY_TP_CD", binding: "hsDtyTpCd", width: "10%" }] },
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: "8%" }] },
        { cells: [{ header: "L_BRND_YN", binding: "brndYn", width: "8%" }] },
        { cells: [{ header: "L_CPNT_YN", binding: "cpntYn", width: "8%" }] },
    ],
    body: [
        {
            cells: [
                {
                    binding: "hsDgt",
                    excel: "A",
                    required: true,
                    validate: (value: any) => {
                        // 값(value)을 비교하여 return true(오류검증 통과) , 이외의 경우 오류검증 실패 처리
                        if (value == "2") return true;
                        else if (value == "4") return true;
                        else if (value == "6") return true;
                        else if (value == "8") return true;
                        else if (value == "12") return true;
                    },
                },
            ],
        },
        { cells: [{ binding: "hsCd", excel: "B", required: true, mask: ptlUtils.setHsCodeMask() }] },
        { cells: [{ binding: "hsDesc", excel: "C", required: true }] },
        {
            cells: [
                {
                    binding: "itmQtyUtCd",
                    type: "code",
                    area: "comnCd",
                    comnCd: "OSC0031",
                    excel: "D",
                    viewType: "value",
                    validate: (v: any, formValues: any) => {
                        // 값(value)을 비교하여 return true(오류검증 통과) , 이외의 경우 오류검증 실패 처리
                        if (formValues.hsDgt == 12) {
                            if (v.length == 3) return true;
                            else return false;
                        }
                        return true;
                    },
                },
            ],
        },
        {
            cells: [
                {
                    binding: "hsDtyTpCd",
                    type: "select",
                    area: "comnCd",
                    comnCd: "OSC0047",
                    excel: "E",
                    viewType: "value",
                    validate: (v: any, formValues: any) => {
                        // 값(value)을 비교하여 return true(오류검증 통과) , 이외의 경우 오류검증 실패 처리
                        if (formValues.hsDgt == 12) {
                            if (v == "VALO" || v == "SPQT" || v == "SPWT" || v == "ALMN" || v == "ALMX") return true;
                            else return false;
                        }
                        return true;
                    },
                },
            ],
        },
        {
            cells: [
                {
                    binding: "useYn",
                    type: "select",
                    options: optionYn,
                    viewType: "value",
                    excel: "F",
                },
            ],
        },
        { cells: [{ binding: "brndYn", type: "text", excel: "G" }] },
        { cells: [{ binding: "cpntYn", type: "text", excel: "H" }] },
    ],
};
